/* global axios */
import ApiClient from './ApiClient';

class IssueClusterSuggestionsAPI extends ApiClient {
  constructor() {
    super('issue_cluster_suggestions', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  accept(id) {
    return axios.post(`${this.url}/${id}/accept`);
  }

  reject(id) {
    return axios.post(`${this.url}/${id}/reject`);
  }
}

export default new IssueClusterSuggestionsAPI();
